export default {
  AUTH_SIGNIN: 'signin',
  AUTH_FORGOT_PASSWORD: 'forgot',
  CHANGE_PASSWORD: 'changepassword',
  NOT_FOUND: '404',
  FIND_USER: 'finduser',
  INSPECT_USER: 'inspectuser',
  FEEDBACK: 'feedback',
  COUPONS: 'coupons',
  FAILED_DEMOS: 'faileddemos',
};
